import { FC, useCallback } from 'react';
import { SvgIconComponent } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { useWebgate } from '@xvia/webgate-connect';
import styles from './link-list.module.css';

export interface LinkListItem {
  text: string;
  Icon?: SvgIconComponent;
  link: string;
  isExternal?: boolean;
  onClick?: () => void;
}

export interface LinkListProps {
  title: string;
  Icon: SvgIconComponent;
  linkList: LinkListItem[];
  handleLinkClick?: (
    e: React.MouseEvent<HTMLAnchorElement>,
    link: string,
    isExternal?: boolean
  ) => void;
}

export const LinkList: FC<LinkListProps> = ({
  title,
  Icon: TitleIcon,
  linkList,
  handleLinkClick,
}) => {
  return (
    <nav
      aria-label={`Navigation links for ${title}`}
      className={styles.linkList}
    >
      <ul className={styles.linkItems}>
        {linkList.map(({ text, Icon, link, isExternal, onClick }, index) => (
          <li key={index} className={styles.linkItem}>
            <a
              href={link}
              target={isExternal ? '_blank' : undefined}
              rel={isExternal ? 'noreferrer' : undefined}
              className={styles.link}
              onClick={(e) => {
                if (onClick) {
                  e.preventDefault();
                  onClick();
                  return;
                }
                if (handleLinkClick) {
                  handleLinkClick(e, link, isExternal);
                }
              }}
            >
              {text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};
